// Third party
import { useEffect } from "react";
import Router from "./boiler/Router";
import { Helmet } from "react-helmet";

function App() {
  useEffect(() => {
    if (import.meta.env.PROD) {
      (function (w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({
          "gtm.start": new Date().getTime(),
          event: "gtm.js",
        });
        var f = d.getElementsByTagName(s)[0];
        var j = d.createElement(s);
        // eslint-disable-next-line
        var dl = l != "dataLayer" ? "&l=" + l : "";
        j.async = true;
        j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
        f.parentNode.insertBefore(j, f);
      })(window, document, "script", "dataLayer", "GTM-NVFJQWP");
    }
  }, []);

  return (
    <div className="App">
      <Helmet>
        <meta name="theme-color" content="#293881" />
        <meta
          name="description"
          content="Hur säkra är dina internetvanor? Ta reda på svaret med Nätklok."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://natklok.sakerhetskollen.se/" />
        <meta property="og:title" content="Nätklok - Hur säkra är dina internetvanor?" />
        <meta property="og:description" content="Ta reda på svaret i vårt test." />
        <meta property="og:image" content={"/thumbnail.jpg"} />
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:url" content="https://natklok.sakerhetskollen.se/" />
        <meta property="twitter:title" content="Nätklok - Hur säkra är dina internetvanor?" />
        <meta property="twitter:description" content="Ta reda på svaret i vårt test." />
        <meta property="twitter:image" content={"/thumbnail.jpg"} />
        <link rel="apple-touch-icon" href={"/logo192.png"} />
        <link rel="manifest" href={"/manifest.json"} />
      </Helmet>
      <Router />
    </div>
  );
}

export default App;
